import { h, Component } from 'preact';
import style from './index.less'
import LoadingIcon from '../LoadingIcon';

export default (props)=>{
    const buttonID = props.id || '';

    let classes = [style.button]
    props.class && classes.push(props.class)

    const theme = props.theme === "gray" ? style.theme_gray : style.theme_orange
    if(theme) classes.push(theme);
    
    return (
        <button id={buttonID} type={props.type || ''} class={classes.join(' ')} onClick={props.onClick} disabled={props.disabled}>
            {props.spinner? 
                <div class={style.spinnerContainer}>
                    <LoadingIcon width={100} height={75} loadDots={true}/>
                </div>
            :
                props.children
            }
        </button>
    )
}


// WEBPACK FOOTER //
// ./components/elements/Button/index.js